import React, { useState, useRef } from 'react'
import { Input } from 'toonswap-uikit'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'

const StyledInput = styled(Input)`
  background: #2c3537 !important;
  border-radius: 12px;
  border: 2px solid #252c2d;
  margin-left: auto;
  min-height: 40px;
  color: #ffffff !important;
  outline: none !important;

  ::placeholder {
    color: #b0b0b0;
    opacity: 0.9;
  }

  :focus,
  :focus-visible,
  :active {
    outline: none !important;
    box-shadow: none !important;
    border-color: #ff7b04;
  }
`

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  ${({ theme }) => theme.mediaQueries.sm} {
    width: 234px;
    display: block;
  }
`

const Container = styled.div<{ toggled: boolean }>``

interface Props {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const SearchInput: React.FC<Props> = ({ value, onChange }) => {
  const [toggled, setToggled] = useState(false)
  const inputEl = useRef(null)
  const { t } = useTranslation()

  return (
    <Container toggled={toggled}>
      <InputWrapper>
        <StyledInput
          ref={inputEl}
          value={value}
          onChange={onChange}
          placeholder={t('Search Pools')}
          onBlur={() => setToggled(false)}
        />
      </InputWrapper>
    </Container>
  )
}

export default SearchInput
